import { axios } from '@/api/axios';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyADTmxIK_-qt3EEDl5Tq1TR_YGBzrXkaVQ',
  authDomain: 'whm-pwa.firebaseapp.com',
  projectId: 'whm-pwa',
  storageBucket: 'whm-pwa.firebasestorage.app',
  messagingSenderId: '844258842109',
  appId: '1:844258842109:web:dcfcad8834ba36cc1c3594',
  measurementId: 'G-RRKSVJ3MFS',
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Lazy initialize messaging - not supported in all environments (e.g., Firefox
// iOS, Telegram WebView). Firebase's `getMessaging` runs an async support check
// internally and throws an unhandled rejection on unsupported browsers, so a
// try/catch around it doesn't help - we have to gate on `isSupported()` first.
let messagingPromise: Promise<ReturnType<typeof getMessaging> | null> | null = null;

const getMessagingInstance = (): Promise<ReturnType<typeof getMessaging> | null> => {
  if (!messagingPromise) {
    messagingPromise = isSupported()
      .then((supported) => (supported ? getMessaging(app) : null))
      .catch(() => null);
  }
  return messagingPromise;
};

export const fcmApi = {
  /**
   * Returns the stored token for this device, or null when the backend has
   * none yet. The backend answers that case with a 404, which is the normal
   * first-visit path, so it is accepted here instead of surfacing as an error.
   */
  checkExistingToken: async () => {
    const { platform, userAgent } = navigator;

    const response = await axios.get(
      `/fcm/tokens/available?platform=${platform}&user_agent=${userAgent}`,
      { validateStatus: (status) => status === 200 || status === 404 },
    );
    return response.status === 404 ? null : response.data;
  },
  createFcmToken: async () => {
    const messagingInstance = await getMessagingInstance();
    if (!messagingInstance) {
      console.warn('Firebase Messaging not available');
      return null;
    }

    const { platform, userAgent } = navigator;

    if (!('Notification' in window)) {
      console.warn('Notifications not supported');
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('Notification permission not granted');
      return null;
    }

    const token = await getToken(messagingInstance, {
      vapidKey:
        'BNrNGDTC0kFf3a9aGUK_ZF8wOF4E4MIkKoOMUaCIx_hNYoyGUppRtjFeIO6bBvi68uVeJ-pyohfB7BuaAwtujAs',
    });

    const response = await axios.post('/fcm/tokens', { token, platform, user_agent: userAgent });
    return response.data;
  },
  markedNotificationAsRead: async (payload: { notificationId: string }) => {
    const { notificationId } = payload;
    const response = await axios.patch(`/notifications/${notificationId}/mark-as-read`);
    return response.data;
  },
};
